import { FC } from "react";
import { LastFewDaysProps } from "./types";
import { Column, ScrollRow } from "../../containers";
import { JustifyContent } from "../../containers/types";
import { useThemeStore } from "../../../stores";
import { Text } from "../../typography";
import {
  getDate,
  getDaysFa,
  getDaysFromNow,
  getRangeDay,
  isTimeInRange,
} from "../../../utils";

const LastFewDays: FC<LastFewDaysProps> = ({
  selectedDay,
  setSelectedDay,
  props,
  className = "",
  style = {},
  days = 40,
}) => {
  const theme = useThemeStore((state) => state.theme);

  return (
    <ScrollRow
      style={{ width: "100%", ...style }}
      gap={10}
      props={props}
      className={className}
      height={90}
    >
      {Array.from(new Array(days)).map((_, idx) => {
        const thisDay = getDaysFromNow(idx * -1);
        return (
          <Column
            key={idx}
            style={{
              width: 55,
              height: 64,
              borderRadius: 15,
              border: `1px solid ${
                isTimeInRange(thisDay, selectedDay)
                  ? theme.primary
                  : "transparent"
              }`,
              cursor: "pointer",
            }}
            className="transition"
            justifyContent={JustifyContent.Evenly}
            background={theme.overlay}
            props={{
              onClick: () => setSelectedDay(getRangeDay(thisDay)),
            }}
          >
            <Text size={12} color={theme.textOnOverlay}>
              {String(getDate(thisDay))}
            </Text>
            <Text size={12} color={theme.textOnOverlay}>
              {String(getDaysFa(thisDay))}
            </Text>
          </Column>
        );
      })}
    </ScrollRow>
  );
};

export default LastFewDays;
